<template>
  <div class="swiper-ctner">
    <div class="md-card-media">
      <swiper :options="swiperOption"  ref="mySwiper">
        <!-- 这是轮播的小圆点 -->
        <div class="swiper-pagination" slot="pagination">
        </div>
        <!-- 这部分放你要渲染的那些内容 -->
        <swiper-slide v-for="(item, idx) in items" :key="idx">
          <router-link v-if="item.link" :to=item.link>
            <img :src="item.background" :alt="item.title"/>
          </router-link>
          <img v-else :src="item.background" :alt="item.title">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script type="text/javascript">
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  // eslint-disable-next-line
  require('swiper/dist/css/swiper.css');

  export default {
    name: 'Swiper',
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        swiperOption: {
          // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
          notNextTick: true,
          pagination: {
            el: '.swiper-pagination'
          },
          slidesPerView: 'auto',
          centeredSlides: true,
          paginationClickable: true,
          autoplay: 2500,
          autoplayDisableOnInteraction: false,
          spaceBetween: 50,
          loop: false,
          onSlideChangeEnd: swiper => {
            // 这个位置放swiper的回调方法
            this.page = swiper.realIndex + 1;
            this.index = swiper.realIndex;
          },
          effect: 'coverflow',
          grabCursor: true,
          coverflowEffect: {
            rotate: 0,
            stretch: -80,
            depth: 150,
            modifier: 1
          }
        }
      };
    },
    props: ['items'],
    // 定义这个sweiper对象
    computed: {

      swiper () {
        return this.$refs.mySwiper.swiper;
      }
    },
    mounted () {
      // 这边就可以使用swiper这个对象去使用swiper官网中的那些方法
      this.swiper.slideTo(0, 0, false);
    }

  };
</script>

<style lang="scss">
  .swiper-ctner{
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 20px;
    height: 5rem;
    overflow: hidden;
    position: relative;
    z-index: 1;

    .swiper-wrapper{
      margin-top: .10rem;
    }
    .swiper-container{
      padding-bottom: 10px;
      .swiper-slide{
        width: 74.5%;
        height: 4.86rem;
        border-radius: 4px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 0 .13rem rgba(0, 0, 0, .21);
        &.swiper-slide-active{
          box-shadow: 0 0 .18rem rgba(0, 204, 255, .32);
        }
        .swiper-slide-shadow-left,
        .swiper-slide-shadow-right{
          display: none!important;
        }
        img{
          display: block;
          width: auto;
          height: 100%;
        }
      }
    }

    .swiper-pagination{
      top: .50rem;
      left: auto!important;
      right: 1.45rem;
      text-align: right;
      width: 3rem!important;
      height: 0.50rem;
      .swiper-pagination-bullet {
        display: inline-block;
        width: .10rem;
        height: .10rem;
        border-radius: 10px;
        background-color: #a0a0a0;
        opacity: 1;
        margin-left: .09rem;
        margin-right: .09rem;
      }
      .swiper-pagination-bullet-active{
        background: #00ccff;
        border-radius: 0;
        transform: rotate(45deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue